export default {
    ca: {
        availableMaps: 'Els meus mapes',
        newMap: 'Fer un nou mapa',
        searchBox: {
            searchPlaceholder: 'Escriu aquí...',
            showing: 'Mostrant',
            showingResults: 'resultats',
            rank: 'Popularitat',
            relevance: 'Nom',
            date: 'Data',
            noResults: 'No hi ha resultats per mostrar',
            mapesDerivats: 'Mostrar mapes derivats',
            totsElsMapes: 'Mostrar mapes propis',
            mapesHeretats: 'Mostrar mapes heretats'
        },
        titleCol: 'Deixar de col·laborar',
    },
    es: {
        availableMaps: 'Mis mapas',
        newMap: 'Crear nuevo mapa',
        searchBox: {
            searchPlaceholder: 'Escribe aquí...',
            showing: 'Mostrando',
            showingResults: 'resultados',
            rank: 'Popularidad',
            relevance: 'Nombre',
            date: 'Fecha',
            noResults: 'No hay resultados para mostrar',
            mapesDerivats: 'Mostrar mapas derivados',
            totsElsMapes: 'Mostrar mapas propios',
            mapesHeretats: 'Mostrar mapas heredados'
        },
        titleCol: 'Dejar de colaborar',
    },
    en: {
        availableMaps: 'My maps',
        newMap: 'Create new map',
        searchBox: {
            searchPlaceholder: 'Type here...',
            showing: 'Showing',
            showingResults: 'results',
            rank: 'Popularity',
            relevance: 'By name',
            date: 'Date',
            noResults: 'There are no results to display',
            mapesDerivats: 'Show derived maps',
            totsElsMapes: 'Show my maps',
            mapesHeretats: 'Show inherited maps'
        },
        titleCol: 'Stop collaboration',
    },
};



// WEBPACK FOOTER //
// ./src/perfil/components/perfil-list/perfil-list-translations.js